import React from "react";
import PropTypes from "prop-types";
import "./ResultDisplay.css";

function ResultDisplay({ total }) {
  return (
    <div className="result-container">
      <h2>Total Amount</h2>
      <div className="result-amount">RM {total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
    </div>
  );
}

ResultDisplay.propTypes = {
  total: PropTypes.number.isRequired
};

export default ResultDisplay;
